import React from 'react';
import clsx from 'clsx';
import { Icon } from 'bs-unified-ui';
import { isString } from 'lodash';

type MenuItemProps = {
  children?: React.ReactNode;
  isSub?: boolean;
  dot?: boolean;
  icon?: string | React.ReactElement;
  id?: string;
  dropdown?: boolean;
  open?: boolean;
  active?: boolean;
  onClick?: () => void;
  dataTestId?: string;
  disabled?: boolean;
};
export const MenuItem = ({
  children,
  isSub,
  dot = false,
  icon,
  dropdown = false,
  open = false,
  active = false,
  onClick,
  id,
  dataTestId,
  disabled,
}: MenuItemProps) => {
  const handleClick = () => {
    if (typeof onClick === 'function') onClick();
  };

  const renderIcon = () => {
    if (!icon) return null;
    if (isString(icon))
      return (
        <Icon name={icon} size={16} className='bs-unified__btn-menu__icon' />
      );
    return icon;
  };

  return (
    <div
      role='presentation'
      id={id}
      data-testid={dataTestId}
      onClick={handleClick}
      className={clsx('bs-unified__btn-menu', {
        'bs-unified__btn-menu-sub': isSub,
        'bs-unified__btn-menu-dropdown': dropdown,
        'open': open,
        'active': active,
        'disabled': disabled,
      })}
    >
      {renderIcon()}
      <span className='bs-unified__btn-menu__text'>{children}</span>
      {dot && <span className='bs-unified__btn-menu__dot' />}
      {dropdown && (
        <Icon
          name='arrow-down'
          size={7}
          className='bs-unified__btn-menu__icon icon-dropdown'
        />
      )}
    </div>
  );
};
